import _ from "lodash";
import dayjs from 'dayjs';
import { PROJECT_DOMAIN } from "../config";


const toTitleCase = str => {
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}

// Random alphanumeric password
const generateRandomPasscode = (length = 7) => _.times(length, () => _.random(35).toString(36)).join('');


const dateFormat = "DD-MM-YYYY";
const formatDate = val => val ? val.format(dateFormat) : null;
const recoverDate = date => date ? dayjs(date, dateFormat) : null;


const extractLastPathnamePart = url => {

    const rawUrl = url.trim();

    let lastPart = null;

    try {

        const url = new URL(rawUrl);
        
        const pathname = url.pathname;

        if (!url.hostname.includes(PROJECT_DOMAIN)) {
            throw new Error(
                `URL doesn't represent a Shodl Link! Received: "${rawUrl}"`
            );
        }

        lastPart = pathname.substring(pathname.lastIndexOf("/") + 1);
    
    } catch (error) {

        if (rawUrl.includes("/")){
            throw error;
        } else {
            lastPart = rawUrl;
        }

    }

    return lastPart;
}


function getRandomHexColor() {
    const randomInt = Math.floor(Math.random() * 16777215); // 0xFFFFFF
    return `#${randomInt.toString(16).padStart(6, "0")}`;
}


export {
    toTitleCase,
    generateRandomPasscode,
    dateFormat,
    formatDate,
    recoverDate,
    extractLastPathnamePart,
    getRandomHexColor,
}